import React from "react";

import { DataType } from "@/jenesys-types/data/enums";

import { CrudRoute } from "@/components/common/crud/CrudRoute/CrudRoute";

export const ReconciliationRoute: React.FC = () => (
  <CrudRoute
    dataType={DataType.Reconciliation}
    title="Bank Reconciliations"
    canDelete={false}
  />
);
